import { useEffect, useState } from "react";
import fileUtils from "../../utils/fileUtils";

const useDocumentsForAllSites = ({ data }) => {
  const [sites, setSites] = useState([]);
  useEffect(() => {
    const getTrees = async () => {
      const trees = [];
      for (let i = 0; i < data.length; i++) {
        // The folder tree keys each site by its id, and MUI X throws on a duplicate id.
        if (trees.some((site) => site.externalId === data[i].accountExternalId))
          continue;
        trees.push({
          externalId: data[i].accountExternalId,
          name: data[i].accountName,
          tree: await fileUtils.getObjectFromFileNames(
            data[i].documents,
            data[i].accountExternalId
          ),
        });
      }
      if (!data?.length) return;
      setSites(trees);
    };
    getTrees();
  }, [data]);

  return sites;
};
export default useDocumentsForAllSites;
